<app-iota-modal i18n-title title="Office data" [modalOptions]="modalOptions" (close$)="onCancelClick()">
    <div modal-body class="p-5 flex flex-col gap-3">
        <app-section-header text="Office name" i18n-text> </app-section-header>

        <div class="w-full mb-10 grid grid-cols-2 justify-between items-start gap-2 gap-x-16">
            <div class="flex flex-row items-center gap-2">
                <span class="min-w-1/4" i18n>Office Name: *</span>
                <input type="text" class="flex-1 input input-bordered" [(ngModel)]="data.office.name" />
            </div>

            <div class="flex flex-row items-center gap-2">
                <span class="min-w-1/4" i18n>Customer-Office-No.:</span>
                <input type="text" class="flex-1 input input-bordered" [disabled]="true" [(ngModel)]="data.office.companyOfficeNumber" />
            </div>
        </div>

        <app-section-header i18n-text text="Address"></app-section-header>

        <app-address
            [showEditButton]="false"
            [editMode]="true"
            *ngFor="let address of data.office.addresses"
            [showSaveButton]="false"
            [address]="address"
            (editCancelled)="deleteAddress(address)"
            [showAddressSubtitle]="false"
        >
        </app-address>
    </div>

    <div modal-footer class="flex grow justify-between">
        <button class="btn btn-primary" (click)="onCancelClick()" i18n>Cancel</button>
        <button class="btn btn-primary" [disabled]="!isFormValid" [ngClass]="{ loading: createLoading }" (click)="onSaveClick()" i18n>
            Create
        </button>
    </div>
</app-iota-modal>
